import React, {createRef, Fragment} from 'react';

import MultiPageForm from "../Base/ReactMultiPageForm";
import UserInput from "../UI/ReactUserInput";
import BootstrapRow from "ui/BootstrapRow";
import UserInputCheckbox from "../UI/ReactUserInputCheckbox";
import DropdownSchoolYear from "../UI/ReactDropdownSchoolYear";
import DropdownGender from "../UI/ReactDropdownGender";
import UserInputTextarea from "../UI/ReactUserInputTextarea";
import AsylumStatusForm from "root/Base/AsylumStatusForm";
import {checkError} from '../DataFunctions/BaseDataFns'
import StatutoryAssessmentForm from "root/Base/StatutoryAssessmentForm";
import BootstrapCol from "ui/BootstrapCol";
import FullTimeEducationForm, {emptyFormData} from "root/Base/FullTimeEducationForm";

import FieldsetContainer from "root/Base/FieldsetContainer";
import RiskOfExclusionForm, {emptyRiskOfExclusionData} from "root/Base/RiskOfExclusionForm";
import StarFundingForm, {emptyStarFundingData} from "root/Base/StarFundingForm";
import EducationStatusForm from "root/Base/EducationStatusForm";
import TransitionForm, {emptyTransitionData} from "root/Base/TransitionForm";

export default class ChildHeaderForm extends React.Component
{
   static get defaultProps()
   {
      var v =
         {
            prevButtonRequired: true,
            nextButtonRequired: true,
            mode: 'create',
            showAdditionalDetails: false,
            showSchoolDetails: false
         };

      return v;
   }

   constructor(props)
   {
      super(props);

      this.keyCount = 1;

      this.processProps(this.props);

      this.state.isSEN_K_Flag = false;
      //this.state.isTopUpFlag = false;

      if (this.state.child.needs == null)
      {
         this.state.isSENFlag = false

         if (this.state.child.sen_k_flag == 1)
         {
            this.state.isSEN_K_Flag = true;
         }
      }
      else
      {
         this.state.isSENFlag = true
      }

      //this.state.isTopUpFlag = this.state.child.top_up_funding_flag == 0 ? false : true;
      this.state.isStatutoryReferralFlag = this.state.child.statutory_referral_flag == 1 ? true : false;

      this.state.mode = this.props.mode;

      this.state.forceOpen = false;

      this.asylumForm = createRef();
      this.statutoryAssessmentForm = createRef();
      this.transitionForm = createRef();
      this.educationStatusForm = createRef();
      this.riskOfExclusionForm = createRef();
      this.starFundingForm = createRef();
      this.fullTimeEducationForm = createRef();
      this.InputChildIsPPPlus = createRef();
      this.InputIsReceivingFunding = createRef();
      this.InputFundingStartDate = createRef();
      this.InputFundingEndDate = createRef();
      this.InputNeeds = createRef();
      this.InputProvision = createRef();
      this.InputAlternateProvision = createRef();
      this.InputAlternateProvisionNotes = createRef();
      this.InputFirstName = createRef();
      this.InputMiddleName = createRef();
      this.InputLastName = createRef();
      this.InputSchoolName = createRef();
      this.InputTeacherName = createRef();
      this.InputDateOfLastReview = createRef();
      this.InputDateOfStatement = createRef();
      this.InputChildBirthDate = createRef();
      this.InputSchoolYear = createRef();
      this.InputUPN = createRef();
      this.InputGender = createRef();

      this.onChangeChild = this.onChangeChild.bind(this);
      this.onCancelChangeChild = this.onCancelChangeChild.bind(this);
      this.onSaveChildChanges = this.onSaveChildChanges.bind(this);
      this.onChangeSEN = this.onChangeSEN.bind(this);
      this.onChangeSEN_K = this.onChangeSEN_K.bind(this);
      //this.onChangeTopUp = this.onChangeTopUp.bind(this);
      this.onChangeStatutoryReferral = this.onChangeStatutoryReferral.bind(this);
      this.onChangeFullTimeEducation = this.onChangeFullTimeEducation.bind(this);
   }

   /**
    * Sets the initial 'valid' state and value when the initial props are supplied
    *
    * @param {props} nextProps - props object passed by React.
    * @return {void}
    */
   UNSAFE_componentWillReceiveProps(nextProps)
   {
      this.processProps(nextProps);
   }

   processProps(props)
   {
      const childObj = props.child == null ? {} : props.child;

      if (this.state == null)
      {
         this.state = {child: childObj};
      }
      else
      {
         this.state.child = childObj;
      }
   }

   updateChild(child_details)
   {
      const data = {child_details: child_details};

      const url = Globals.APIFolder + '/children/' + child_details.child_id;

      $.ajax({
         type: 'PUT',
         url: url,
         data: data,
         async: false,
         success: (data) => {

            if (checkError(data))
            {
               if (data.data != null)
               {
                  var needsInsertStatus = data.data.needs.status;

                  if (needsInsertStatus.operation === 'insert')
                  {
                     const newSENRecordId = needsInsertStatus.insertId;

                     const oldChild = child_details;

                     let oldNeeds = oldChild.needs;

                     oldNeeds.sen_id = newSENRecordId;

                     oldChild.needs = oldNeeds;

                     this.setState({isSENFlag: true, child: oldChild, forceOpen: false, mode: 'view'});

                     this.props.refresh();
                  }
                  else
                  {
                     if (needsInsertStatus.operation === 'delete')
                     {
                        let oldChild = child_details;

                        oldChild.needs = null;

                        this.setState({isSENFlag: false, child: oldChild, forceOpen: false, mode: 'view'});

                        this.props.refresh();

                     }
                     else
                     {
                        // It was just a straight update with no new Record

                        this.setState({isSENFlag: true, forceOpen: false, mode: 'view'});

                        this.props.refresh();

                     }
                  }
               }
               else
               {
                  this.setState({isSENFlag: false, child: child_details, forceOpen: false, mode: 'view'});

                  this.props.refresh();

               }
            }
         },
         error: (jqXHR, textStatus, error) =>
         {
            handleAjaxError(jqXHR, textStatus, error);
         }
      });
   }

   onChangeChild()
   {
      this.setState({forceOpen: true, mode: 'edit'});
   }

   onCancelChangeChild()
   {
      this.setState({mode: 'view'});
   }

   isFormValid = () =>
   {
      let valid = true;

      if ((this.asylumForm.current !== null && !this.asylumForm.current.formIsValid()))
      {
         valid = false;
      }

      if ((this.statutoryAssessmentForm.current !== null && !this.statutoryAssessmentForm.current.formIsValid()))
      {
         valid = false;
      }

      if ((this.riskOfExclusionForm.current !== null && !this.riskOfExclusionForm.current.formIsValid()))
      {
         valid = false;
      }

      if ((this.starFundingForm.current !== null && !this.starFundingForm.current.formIsValid()))
      {
         valid = false;
      }

      if ((this.transitionForm.current !== null && !this.transitionForm.current.formIsValid()))
      {
         valid = false;
      }

      if ((this.educationStatusForm.current !== null && !this.educationStatusForm.current.formIsValid()))
      {
         valid = false;
      }

      if ((this.fullTimeEducationForm.current !== null && !this.fullTimeEducationForm.current.formIsValid()))
      {
         valid = false;
      }

      if ((this.InputChildIsPPPlus.current !== null && !this.InputChildIsPPPlus.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputIsReceivingFunding.current !== null && !this.InputIsReceivingFunding.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputFundingStartDate.current !== null && !this.InputFundingStartDate.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputFundingEndDate.current !== null && !this.InputFundingEndDate.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputNeeds.current !== null && !this.InputNeeds.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputProvision.current !== null && !this.InputProvision.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputAlternateProvision.current !== null && !this.InputAlternateProvision.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputAlternateProvisionNotes.current !== null && !this.InputAlternateProvisionNotes.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputFirstName.current !== null && !this.InputFirstName.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputMiddleName.current !== null && !this.InputMiddleName.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputLastName.current !== null && !this.InputLastName.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputChildBirthDate.current !== null && !this.InputChildBirthDate.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputUPN.current !== null && !this.InputUPN.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputSchoolYear.current !== null && !this.InputSchoolYear.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputGender.current !== null && !this.InputGender.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputDateOfLastReview.current !== null && !this.InputDateOfLastReview.current.isValid()))
      {
         valid = false;
      }

      if ((this.InputDateOfStatement.current !== null && !this.InputDateOfStatement.current.isValid()))
      {
         valid = false;
      }

      return valid;
   }

   onSaveChildChanges()
   {
      if (this.isFormValid())
      {
         const child_details = this.getFormData();

         this.updateChild(child_details);
      }
      else
      {
         this.setState({displayErrors: true});
      }
   }

   getFormData()
   {
      let childDetails = this.state.child;

      childDetails.firstname = this.InputFirstName.current.getValue();
      childDetails.surname = this.InputLastName.current.getValue();
      childDetails.middlename = this.InputMiddleName.current.getValue();
      childDetails.dmy_date_of_birth = this.InputChildBirthDate.current.getValue();
      childDetails.dmy_date_became_lac = this.refs.InputDateBecameLac.getValue();
      childDetails.dmy_date_last_became_lac = this.refs.InputDateLastBecameLac.getValue();
      childDetails.child_upn = this.InputUPN.current.getValue();
      childDetails.gender = this.InputGender.current.getValue();

      childDetails.year_id = this.InputSchoolYear.current.getValue();
      childDetails.year_name = this.yearDescription(childDetails.year_id);

      if (!this.isTeacher())
      {
         if ( this.InputChildIsPPPlus.current !== null)
         {
            const ppPlusFlag = this.InputChildIsPPPlus.current.getValue();

            if (ppPlusFlag == true)
            {
               childDetails.ppplus_flag = 1;
            }
            else
            {
               childDetails.ppplus_flag = 0;
            }
         }
         else
         {
            // If the control isn't there, the child is too old
            childDetails.ppplus_flag = 0 ;
         }
      }
      else
      {
         childDetails.ppplus_flag = this.state.child.ppplus_flag;
      }

      let SENFlag = this.refs.InputChildIsSEN.getValue();
      let SEN_K_Flag = this.refs.InputChildIsSEN_K.getValue();

      if (SENFlag == true)
      {
         if (childDetails.needs == null)
         {
            // Child didn't have a SEN record before, so we need to create one
            childDetails.needs = {};
            childDetails.sen_id = 0;
         }

         // Can only have SEN OR SEN-K
         childDetails.sen_k_flag = 0;

         childDetails.needs.needs = this.InputNeeds.current.getValue()
         childDetails.needs.provision = this.InputProvision.current.getValue()
         childDetails.needs.dmy_last_review_date = this.InputDateOfLastReview.current.getValue()
         childDetails.needs.dmy_statement_date = this.InputDateOfStatement.current.getValue()
      }
      else
      {
         if (childDetails.needs != null)
         {
            childDetails.needs = {};
            childDetails.needs.delete_flag = 1;
         }

         if (SEN_K_Flag == true)
         {
            // Can only have SEN OR SEN-K
            childDetails.sen_k_flag = 1;
         }
         else
         {
            // Can only have SEN OR SEN-K
            childDetails.sen_k_flag = 0;
         }
      }

      if ( this.state.child.year_group_id > 3)
      {
         const bool_bursary_flag = this.refs.InputChildBursaryAppliedFor.getValue();

         childDetails.bursary = bool_bursary_flag == true ? 'Y' : 'N';
         childDetails.bursary_notes = this.refs.InputChildBursaryNotes.getValue();

         // Aspirations removed August 2023 as part of Post16 implementation
         //childDetails.long_term_aspirations = this.refs.InputLongTermAspirations.getValue();
         childDetails.long_term_aspirations = null;
      }
      else
      {
         childDetails.bursary = null;
         childDetails.bursary_notes = null;
         childDetails.long_term_aspirations = null;
      }

      const riskOfExclusionDetails = this.riskOfExclusionForm.current === null ? emptyRiskOfExclusionData : this.riskOfExclusionForm.current.getFormData();

      const statutoryReferralDetails = this.statutoryAssessmentForm.current.getFormData();
      const asylumDetails = this.asylumForm.current.getFormData();
      const educationStatusDetails = this.educationStatusForm.current === null ? {} : this.educationStatusForm.current.getFormData();

      const starFundingDetails = this.starFundingForm.current === null ? emptyStarFundingData : this.starFundingForm.current.getFormData();

      const transitionDetails = this.transitionForm.current === null ? emptyTransitionData : this.transitionForm.current.getFormData();

      const fullTimeEducationDetails = this.fullTimeEducationForm.current === null ? emptyFormData : this.fullTimeEducationForm.current.getFormData();

      childDetails = {...childDetails, ...asylumDetails, ...statutoryReferralDetails, ...fullTimeEducationDetails,
                      ...riskOfExclusionDetails, ...starFundingDetails, ...educationStatusDetails, ...transitionDetails };

      return childDetails;
   }

   isTeacher()
   {
      return this.props.user_type == 5;
   }

   isChildReceivingPPPlus()
   {
      return this.state.child.ppplus_flag == 1;
   }

   hasBursaryBeenAppliedFor()
   {
      return this.state.child.bursary === 'Y';
   }

   rowSchool()
   {
      let teacher_name = "Not Set";

      if (this.state.child.teacher != null)
      {
         teacher_name = this.state.child.teacher.firstname + ' ' + this.state.child.teacher.surname;
      }

      return (
         <BootstrapRow key='schoolStuff'>
            <BootstrapCol width={6} key='schoolNameCol'>
               <UserInput validation={{required: true, maxlen: 50}}
                          id='InputSchoolName'
                          name='InputSchoolName'
                          ref={this.InputSchoolName}
                          labelText='School Name'
                          errorText='You must enter a valid school name'
                          value={this.state.child.school.school_name}
                          readOnly={true}
                          displayErrors={this.state.displayErrors}/>
            </BootstrapCol>
            <BootstrapCol width={6} key='teacherNameCol'>
               <UserInput validation={{required: true, maxlen: 50}}
                          id='InputTeacherName'
                          name='InputTeacherName'
                          ref={this.InputTeacherName}
                          labelText='Teacher Name'
                          errorText='You must enter a valid last name'
                          value={teacher_name}
                          readOnly={true}
                          displayErrors={this.state.displayErrors}/>
            </BootstrapCol>
         </BootstrapRow>
      )
   }

   rowChildName()
   {
      const fieldType = this.props.readonly == true || this.state.mode == 'view' ? "readonly" : '';

      return (
         <BootstrapRow key='childName'>
            <BootstrapCol width={6} key='childFirstNameCol'>
               <UserInput validation={{required: true, maxlen: 50}}
                          id='InputFirstName'
                          name='InputFirstName'
                          ref={this.InputFirstName}
                          labelText='First Name'
                          errorText='You must enter a valid first name'
                          value={this.state.child.firstname}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </BootstrapCol>
            <BootstrapCol width={3} key='childMiddleNameCol'>
               <UserInput validation={{required: false, maxlen: 50}}
                          id='InputMiddleName'
                          name='InputMiddleName'
                          ref={this.InputMiddleName}
                          labelText='Middle Name'
                          errorText='You must enter a valid last name'
                          value={this.state.child.middlename}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </BootstrapCol>
            <BootstrapCol width={3} key='childLastNameCol'>
               <UserInput validation={{required: true, maxlen: 50}}
                          id='InputLastName'
                          name='InputLastName'
                          ref={this.InputLastName}
                          labelText='Last Name'
                          errorText='You must enter a valid last name'
                          value={this.state.child.surname}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </BootstrapCol>
         </BootstrapRow>
      )
   }

   calcSchoolYear(birthdayDateString)
   {
      let birthday = new Date(birthdayDateString);

      let now = new Date();

      let month = now.getMonth();

      let termStartYear = month >= 8 && month <= 12 ? now.getFullYear() : now.getFullYear() - 1;

      // Term start day
      const termStartDate = new Date(termStartYear, 8, 1);

      let upperLimit = [];

      let year = 0;

      for (let years = 4; years < 18; years++)
      {
         const lower = new Date(termStartDate.getFullYear() - years, 8, 1, 0, 0, 0);
         upperLimit.push(lower);

         if (birthday >= lower)
         {
            break;
         }

         year++;
      }

      return year;
   }

   yearDescription(year_id)
   {
      var yrname = "";

      switch (+year_id)
      {
         case 17:
            yrname = "Early Years";
            break;
         case 14:
            yrname = "Nursery";
            break;
         case 15:
            yrname = "Reception";
            break;
         case 1:
            yrname = "Year 1";
            break;
         case 2:
            yrname = "Year 2";
            break;
         case 3:
            yrname = "Year 3";
            break;
         case 4:
            yrname = "Year 4";
            break;
         case 5:
            yrname = "Year 5";
            break;
         case 6:
            yrname = "Year 6";
            break;
         case 7:
            yrname = "Year 7";
            break;
         case 8:
            yrname = "Year 8";
            break;
         case 9:
            yrname = "Year 9";
            break;
         case 10:
            yrname = "Year 10";
            break;
         case 11:
            yrname = "Year 11";
            break;
         case 12:
            yrname = "Year 12";
            break;
         case 13:
            yrname = "Year 13";
            break;
         case 16:
            yrname = "Year 14";
            break;
         case 18:
            yrname = "Year 15";
            break;
         case 19:
            yrname = "Year 16";
            break;
         default:
            yrname = "Grown Up";
            break;
      }

      return yrname;
   }

   onDateSet(e)
   {
      if (this.InputChildBirthDate.current.isValid())
      {
         var dob = this.InputChildBirthDate.current.getValue();

         var dd = dob.substring(0, 2);
         var mm = dob.substring(3, 5);
         var yyyy = dob.substring(6, 10);

         var bdaystring = yyyy + '-' + mm + '-' + dd;

         var yr = this.calcSchoolYear(bdaystring);

         var yrname = "";

         switch (yr)
         {
            case 0:
               yrname = "Nursery";
               break;
            case 1:
               yrname = "Reception";
               break;
            case 2:
               yrname = "Year 1";
               break;
            case 3:
               yrname = "Year 2";
               break;
            case 4:
               yrname = "Year 3";
               break;
            case 5:
               yrname = "Year 4";
               break;
            case 6:
               yrname = "Year 5";
               break;
            case 7:
               yrname = "Year 6";
               break;
            case 8:
               yrname = "Year 7";
               break;
            case 9:
               yrname = "Year 8";
               break;
            case 10:
               yrname = "Year 9";
               break;
            case 11:
               yrname = "Year 10";
               break;
            case 12:
               yrname = "Year 11";
               break;
            case 13:
               yrname = "Year 12";
               break;
            case 14:
               yrname = "Year 13";
               break;
            case 15:
               yrname = "Year 14";
               break;
            case 16:
               yrname = "Year 15";
               break;
            default:
               yrname = "Grown Up";
               break;
         }

         this.setState({child_year: yrname});
      }
   }

   rowChildAge()
   {
      const d = this.props.mode === 'create' ? getFormattedDate(new Date()) : this.state.child.dmy_date_of_birth;

      const fieldType = this.props.readonly == true || this.state.mode == 'view' ? "readonly" : '';

      return (
         <BootstrapRow key='ageRow'>
            <div className='col-md-6' key='bd1'>
               <UserInput validation={{required: true, maxlen: 10, isDate: true}}
                          id='InputChildBirthDate'
                          name='InputChildBirthDate'
                          ref={this.InputChildBirthDate}
                          labelText='Pupil Date of Birth'
                          errorText='You must enter a valid date of birth'
                          value={d}
                          readOnly={fieldType}
                          onBlur={this.onDateSet.bind(this)}
                          displayErrors={this.state.displayErrors}/>
            </div>
            {this.state.mode === 'view' && <div className='col-md-6' key='bd2'>
               <UserInput validation={{required: true, maxlen: 10}}
                          id='InputSchoolYear'
                          name='InputSchoolYear'
                          ref={this.InputSchoolYear}
                          labelText='School Year'
                          errorText=''
                          value={this.state.child.year_name}
                          readOnly='readonly'
                          displayErrors={this.state.displayErrors}/>
            </div>}
            {this.state.mode !== 'view' && <div className='col-md-6' key='bd3'>
               <DropdownSchoolYear
                  ref={this.InputSchoolYear}
                  defaultValue={this.state.child.year_id}
                  key='dropdownYear'
                  label="School Year"/>
            </div>}
         </BootstrapRow>
      )
   }

   rowDateBecameLAC = () =>
   {
      const d = this.props.mode === 'create' ? getFormattedDate(new Date()) : this.state.child.dmy_date_became_lac;
      const d_last = this.props.mode === 'create' ? getFormattedDate(new Date()) : this.state.child.dmy_date_last_became_lac;

      const fieldType = this.props.readonly === true || this.state.mode === 'view' ? "readonly" : '';

      const esw_name = this.state.child.esw == null ? 'Not Set' : this.state.child.esw.firstname + ' ' + this.state.child.esw.surname;

      return (
         <BootstrapRow key='lacDateRow'>
            <div className='col-md-6' key='esw1'>
               <UserInput validation={{required: true, maxlen: 50}}
                          id='InputESW'
                          name='InputESW'
                          ref='InputESW'
                          labelText='ESW Name'
                          errorText='You must enter a valid first name'
                          value={esw_name}
                          readOnly='readonly'
                          displayErrors={this.state.displayErrors}/>
            </div>
            <div className='col-md-3' key='esw2'>
               <UserInput validation={{required: true, maxlen: 10, isDate: true}}
                          id='InputDateBecameLac'
                          name='InputDateBecameLac'
                          ref='InputDateBecameLac'
                          labelText='Date pupil first became CfC'
                          errorText='You must enter a valid date'
                          value={d}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </div>
            <div className='col-md-3' key='esw3'>
               <UserInput validation={{required: false, maxlen: 10, isDate: true}}
                          id='InputDateLastBecameLac'
                          name='InputDateLastBecameLac'
                          ref='InputDateLastBecameLac'
                          labelText='Date pupil last became CfC'
                          errorText='You must enter a valid date'
                          value={d_last}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </div>
         </BootstrapRow>
      )
   }

   rowUPNAndGender()
   {
      const fieldType = this.props.readonly === true || this.state.mode === 'view' ? "readonly" : '';

      return (
         <BootstrapRow key='upnRow'>
            <div className='col-md-6' key='esw3'>
               <UserInput validation={{required: false, maxlen: 15}}
                          id='InputUPN'
                          name='InputUPN'
                          ref={this.InputUPN}
                          labelText='Unique Pupil Number (UPN)'
                          errorText='You must enter a valid UPN'
                          value={this.state.child.child_upn}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </div>
            {this.state.mode === 'view' && <div className='col-md-6' key='esw4'>
               <UserInput validation={{required: true, maxlen: 10}}
                          id='InputGender'
                          name='InputGender'
                          ref={this.InputGender}
                          labelText='Gender'
                          errorText='You must enter a valid gender'
                          value={this.state.child.gender}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </div>}
            {this.state.mode !== 'view' && <div className='col-md-6' key='esw5'>
               <DropdownGender
                  ref={this.InputGender}
                  defaultGender={this.state.child.gender}
                  key='dropdownGender'
                  label="Select pupil's Gender"/>
            </div>}
         </BootstrapRow>
      )

   }

   buttonRow()
   {
      if (this.props.allowChange === true)
      {
         if (this.state.mode === 'view')
         {
            return (
               <BootstrapRow key='btnRow'>
                  <div key='spc' className='col-md-6'/>
                  <div key='modBtn' className='col-md-6'>
                     <button onClick={this.onChangeChild} type='button' className='btn btn-sm btn-info'
                             style={{float: 'right'}}>Modify Pupil Details
                     </button>
                  </div>
               </BootstrapRow>
            )
         }
         else
         {
            return (
               <BootstrapRow key='btnRow'>
                  <div key='spc' className='col-md-6'/>
                  <div key='saveBtn' className='col-md-6'>
                     <button onClick={this.onSaveChildChanges} type='button' className='btn btn-success btn-sm'
                             style={{float: 'right'}}>Save Changes
                     </button>
                     <button onClick={this.onCancelChangeChild} type='button' className='btn btn-sm'
                             style={{float: 'right', marginRight: '15px'}}>Cancel Changes
                     </button>
                  </div>
               </BootstrapRow>
            )
         }
      }
      else
      {
         return (
            <BootstrapRow key='btnRow'>
               <div key='spc' className='col-md-6'/>
               <div key='spc2' className='col-md-6'/>
            </BootstrapRow>
         )
      }
   }

   // ==============================================================================================================
   // Everything below here is inside the SEN collapsible row
   ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

   onChangeSEN(newValue)
   {
      this.setState({isSENFlag: newValue});
   }

   onChangeSEN_K(newValue)
   {
      this.setState({isSEN_K_Flag: newValue});
   }

   /* onChangeTopUp(newValue)
   {
      this.setState({isTopUpFlag: newValue});
   }
   */


   onChangeStatutoryReferral(newValue)
   {
      this.setState({isStatutoryReferralFlag: newValue});
   }

   rowChildIsSEN_K_Flag()
   {
      const fieldType = this.state.isSENFlag == true || this.props.readonly == true || this.state.mode == 'view' ? "readonly" : '';

      return (
         <BootstrapRow key='senkRow'>
            <div className='col-md-12'>
               <UserInputCheckbox readOnly={fieldType}
                                  key='InputChildIsSEN_K'
                                  ref='InputChildIsSEN_K'
                                  defaultValue={this.state.isSEN_K_Flag}
                                  onChange={this.onChangeSEN_K}
                                  label='Is the pupil subject to SEN Support (K)'/>
            </div>
         </BootstrapRow>
      )
   }

   rowChildIsSENFlag()
   {
      const fieldType = this.state.isSEN_K_Flag == true || this.props.readonly == true || this.state.mode == 'view' ? "readonly" : '';

      return (
         <BootstrapRow key='senRow'>
            <div className='col-md-12'>
               <UserInputCheckbox readOnly={fieldType}
                                  key='InputChildIsSEN'
                                  ref='InputChildIsSEN'
                                  defaultValue={this.state.isSENFlag}
                                  onChange={this.onChangeSEN}
                                  label='Is the pupil subject to an Education Health and Care Plan (EHCP)'/>
            </div>
         </BootstrapRow>
      )
   }

   rowPPPlusFlag()
   {
      const fieldType = this.props.readonly == true || this.state.mode == 'view' ? "readonly" : '';

      const isReceivingPPPlusFLag = this.isChildReceivingPPPlus();

      return (
         <BootstrapRow key='pppRow'>
            <div className='col-md-12'>
               <UserInputCheckbox readOnly={fieldType}
                                  key='InputChildIsPPPlus'
                                  ref={this.InputChildIsPPPlus}
                                  defaultValue={isReceivingPPPlusFLag}
                                  label='Is the pupil eligible for Pupil Premium Plus Payments?'/>
            </div>
         </BootstrapRow>
      )
   }

   rowNeedsAndProvision()
   {
      let fieldType = this.props.readonly == true || this.state.mode === 'view' ? "readonly" : '';
      let needsRequired = true

      const needs = this.state.child.needs == null ? '' : this.state.child.needs.needs;
      const provision = this.state.child.needs == null ? '' : this.state.child.needs.provision;

      if (this.state.isSENFlag != true)
      {
         needsRequired = false;
         fieldType = "readonly";
      }

      return (
         <BootstrapRow key='rowNeedsAndProvisionDiv'>
            <BootstrapCol key='InputNeedsDiv' width={6}>
               <UserInputTextarea validation={{required: needsRequired, maxlen: 2000}}
                                  ref={this.InputNeeds} id='InputNeeds' name='InputNeeds' key='InputNeeds'
                                  label='What are the needs?' errorText="You must enter the pupil's needs"
                                  displayErrors={this.state.displayErrors}
                                  value={needs} rows={5} readOnly={fieldType}/>
            </BootstrapCol>
            <BootstrapCol key='InputProvisionDiv' width={6}>
               <UserInputTextarea validation={{required: needsRequired, maxlen: 2000}}
                                  ref={this.InputProvision} id='InputProvision' name='InputProvision'
                                  key='InputProvision'
                                  label='What is the provision?' errorText="You must enter the provision"
                                  displayErrors={this.state.displayErrors}
                                  value={provision} rows={5} readOnly={fieldType}/>
            </BootstrapCol>
         </BootstrapRow>
      )
   }

   rowReviewDates()
   {
      let fieldType = this.props.readonly === true || this.state.mode === 'view' ? "readonly" : '';

      let last_review_date = '';
      let statement_date = '';
      let needsRequired;

      if (this.state.child.needs != null)
      {
         last_review_date = this.state.child.needs.dmy_last_review_date;
         statement_date = this.state.child.needs.dmy_statement_date;
      }

      if (this.state.isSENFlag === true)
      {
         needsRequired = true;
      }
      else
      {
         needsRequired = false;
         fieldType = "readonly";
      }

      return (
         <BootstrapRow key='rowReviewDatesDiv'>
            <div key='InputDateOfLastReviewDiv' className='col-md-6'>
               <UserInput validation={{required: needsRequired, maxlen: 10, isDate: true}}
                          id='InputDateOfLastReview'
                          name='InputDateOfLastReview'
                          key='InputDateOfLastReview'
                          ref={this.InputDateOfLastReview}
                          placeholder='DD/MM/YYYY'
                          labelText='Date of last review'
                          errorText='You must enter a valid date'
                          value={last_review_date}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </div>
            <div key='InputDateOfStatementDiv' className='col-md-6'>
               <UserInput validation={{required: needsRequired, maxlen: 10, isDate: true}}
                          id='InputDateOfStatement'
                          name='InputDateOfStatement'
                          key='InputDateOfStatement'
                          ref={this.InputDateOfStatement}
                          placeholder={'DD/MM/YYYY'}
                          labelText='Date of Plan'
                          errorText='You must enter a valid date'
                          value={statement_date}
                          readOnly={fieldType}
                          displayErrors={this.state.displayErrors}/>
            </div>
         </BootstrapRow>
      )
   }

   onChangeFullTimeEducation(newValue)
   {
      this.setState({isFullTimeEducationFlag: newValue});
   }

   row16To19Bursary()
   {
      let lineList = [];

      let fieldType = this.props.readonly == true || this.state.mode == 'view' ? "readonly" : '';

      const d = this.props.mode == 'create' ? false : this.hasBursaryBeenAppliedFor();

      lineList.push(React.createElement('div', {key: this.keyCount++, className: 'col-md-6'},
         React.createElement(UserInputCheckbox, {
            readOnly: fieldType,
            key: this.keyCount++,
            ref: 'InputChildBursaryAppliedFor',
            defaultValue: d,
            onChange: this.onChangeFullTimeEducation,
            label: 'Has 16-19 Bursary been applied for?'
         }, null)
      ));


      lineList.push(React.createElement('div', {key: this.keyCount++, className: 'col-md-6'},
         React.createElement(UserInputTextarea, {
               validation: {required: false, maxlen: 2000},
               ref: 'InputChildBursaryNotes',
               label: 'If NO, who will support the student with application?',
               errorText: "",
               rows: 3,
               value: this.state.child.bursary_notes,
               readOnly: fieldType,
               displayErrors: this.state.displayErrors,
               key: this.keyCount++
            },
            null)));

      return React.createElement(BootstrapRow, {key: this.keyCount++}, lineList);

   }


   rowLongTermAspirations()
   {
      let lineList = [];

      let fieldType = this.props.readonly == true || this.state.mode == 'view' ? "readonly" : '';

      lineList.push(React.createElement('div', {key: this.keyCount++, className: 'col-md-12'},
         React.createElement(UserInputTextarea, {
               validation: {required: false, maxlen: 2000},
               ref: 'InputLongTermAspirations',
               label: 'Long Term Aspirations',
               errorText: "",
               key: this.keyCount++,
               rows: 3,
               value: this.state.child.long_term_aspirations,
               readOnly: fieldType,
               displayErrors: this.state.displayErrors,
            },
            null)));

      return React.createElement(BootstrapRow, {key: this.keyCount++}, lineList);

   }

   allPanelFields()
   {
      const fieldType = this.props.readonly === true || this.state.mode === 'view' ? "readonly" : '';

      const post16 = this.state.child.year_group_id > 3;

      const shouldShowFullTime = this.state.child.year_group_id > 1 && post16 === false;

      return (
         <Fragment>



            <AsylumStatusForm key='asform' ref={this.asylumForm} readOnly={fieldType}
                              displayErrors={this.state.displayErrors} child={this.state.child}/>
            {this.isTeacher() === false && !post16 === true && this.rowPPPlusFlag()}
            <BootstrapRow>
               <BootstrapCol width={12}>
                  <FieldsetContainer title='SEND'>
                     {this.rowChildIsSEN_K_Flag()}
                     {this.rowChildIsSENFlag()}
                     {this.state.isSENFlag === true && this.rowNeedsAndProvision()}
                     {this.state.isSENFlag === true && this.rowReviewDates()}
                  </FieldsetContainer>
               </BootstrapCol>
            </BootstrapRow>

            { post16 === true && <EducationStatusForm key='edform' ref={this.educationStatusForm} readOnly={fieldType} displayErrors={this.state.displayErrors} child={this.state.child}/> }

            <StatutoryAssessmentForm key='saform' ref={this.statutoryAssessmentForm} readOnly={fieldType} displayErrors={this.state.displayErrors} child={this.state.child}/>

            <TransitionForm key='trform' ref={this.transitionForm} readOnly={fieldType} displayErrors={this.state.displayErrors} child={this.state.child}/>

            <RiskOfExclusionForm key='srxform' ref={this.riskOfExclusionForm} readOnly={fieldType} displayErrors={this.state.displayErrors} child={this.state.child}/>

            {shouldShowFullTime === true &&
               <FullTimeEducationForm key='ftform' ref={this.fullTimeEducationForm} readOnly={fieldType} mode='edit'
                                      displayErrors={this.state.displayErrors} child={this.state.child}/>}


            { post16 === false && <StarFundingForm key='starform' ref={this.starFundingForm} readOnly={fieldType}
                                   displayErrors={this.state.displayErrors} child={this.state.child}/> }

            {post16 === true && this.row16To19Bursary()}
            { /* Aspirations removed August 2023 as part of Post16 implementation */ }
            { /*post16 === true && this.rowLongTermAspirations() */}
         </Fragment>
      )
   }

   onCollapseClick()
   {
   }

   collapsiblePanelHeading(id, title)
   {
      return React.createElement('div', {key: this.keyCount++, className: 'panel-heading'},
         React.createElement('h4', {key: this.keyCount++, className: 'panel-title'},
            React.createElement('a', {
               onClick: this.onCollapseClick,
               key: this.keyCount++,
               'data-toggle': 'collapse',
               href: '#' + id
            }, title)));
   }

   collapsiblePanelBody(id)
   {
      if (this.state.forceOpen == true)
      {
         return React.createElement('div', {key: this.keyCount++, id: id, className: 'panel-collapse collapse in'},
            React.createElement('div', {key: 'cheaderpane', className: 'panel-body'}, this.allPanelFields()));

      }
      else
      {
         return React.createElement('div', {key: this.keyCount++, id: id, className: 'panel-collapse collapse'},
            React.createElement('div', {key: 'cheaderpane', className: 'panel-body'}, this.allPanelFields()));
      }

   }

   collapsiblePanelHeadingAndContent()
   {
      var lineList = [];

      lineList.push(this.collapsiblePanelHeading('collapse1', 'Click to show additional details'));
      lineList.push(this.collapsiblePanelBody('collapse1'));

      return lineList;
   }

   collapsibleSENRow()
   {
      return (
         <BootstrapRow key='colSen'>
            <div className='col-md-12'>
               <div className='panel-group' style={{marginTop: '15px'}}>
                  <div className='panel panel-default'>
                     {this.collapsiblePanelHeadingAndContent()}
                  </div>
               </div>
            </div>
         </BootstrapRow>
      )
   }

   formRow()
   {
      let lineList = [];

      let displayNeeds = true;

      if (this.props.needsRequired != null)
      {
         if (this.props.needsRequired == false)
         {
            displayNeeds = false;
         }
      }

      lineList.push(this.rowChildName());

      if (this.props.showSchoolDetails == true)
      {
         lineList.push(this.rowSchool());
      }

      lineList.push(this.rowDateBecameLAC());
      lineList.push(this.rowChildAge());
      lineList.push(this.rowUPNAndGender());

      if (displayNeeds)
      {
         // Provision to switch this row off if we only want the child details header
         if (this.props.showAdditionalDetails == true)
         {
            lineList.push(this.collapsibleSENRow());
            lineList.push(this.buttonRow());
         }
      }

      return React.createElement('div', {key: this.keyCount++, className: 'panel-body'}, lineList);
   }

   render()
   {
      this.keyCount = 0;
      return React.createElement('div', {key: this.keyCount++, className: 'panel panel-default'}, this.formRow());
   }
}
